import { render, staticRenderFns } from "./config.vue?vue&type=template&id=02344a5c&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=02344a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02344a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02344a5c')) {
      api.createRecord('02344a5c', component.options)
    } else {
      api.reload('02344a5c', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=02344a5c&scoped=true&", function () {
      api.rerender('02344a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/temporaryTemplate/scanCodeAndConfirmType/config.vue"
export default component.exports